import { Badge, cn } from '@rematter/ui-web';
import { ThemeColor } from '@rematter/ui-web/types';

import { PaymentStatus } from '../../types/transaction';

import {
  DefaultTranslations,
  useTranslations,
} from '~/modules/trade/i18n/useTranslations';

type PaymentStatusBadgeProps = {
  status: PaymentStatus;
  size?: 'small' | 'xs' | 'default' | 'large';
  className?: string;
};

const statusColors: Record<PaymentStatus, ThemeColor> = {
  Unpaid: 'neutral',
  Partial: 'warning',
  Paid: 'success',
  Voided: 'neutral',
};

const statusLabelMap: Record<
  PaymentStatus,
  (t: DefaultTranslations) => string
> = {
  Unpaid: (t) => t.transactionsView.actions.paymentStatusUnpaid,
  Partial: (t) => t.transactionsView.actions.paymentStatusPartial,
  Paid: (t) => t.transactionsView.actions.paymentStatusPaid,
  Voided: (t) => t.transactionsView.actions.paymentStatusVoided,
};

export const PaymentStatusBadge = ({
  status,
  size = 'small',
  className,
}: PaymentStatusBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge
      color={statusColors[status]}
      size={size}
      className={cn(
        '@PaymentStatusBadge',
        status === 'Voided' && 'line-through',
        className,
      )}
    >
      {statusLabelMap[status](t)}
    </Badge>
  );
};
